import { ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { JeeSession1Service } from '../jee-session1.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { ColDef } from 'ag-grid-community';
import { take } from 'rxjs';
import { NeetRookieNotAppliedComponent } from '../neet-rookie-not-applied/neet-rookie-not-applied.component';

@Component({
  selector: 'app-nee-rookie-hlt-entry',
  templateUrl: './nee-rookie-hlt-entry.component.html',
  styleUrls: ['./nee-rookie-hlt-entry.component.scss']
})

export class NeeRookieHltEntryComponent implements OnInit  {
currentDate: string;
searchCriteria: string = '';
  campusId: any
  programName: any
  admNo: any
  mobileNo: any;
  rowData: any[];
  rowDataEntry: any[];
  remarks: any;
  gender: any;
   options: any[] = [];
  selectedAdmNo: string = '';
  selectedStudent: any = {};
  categoryList: any[] = [];
  selectedCategoryId: any = '';
  remarksDisabled: boolean = true;

  StudentName: any;
  parentName: any;
  cityName: any;
  campusName: any;
  examType: any;
  neetApplicationNo: any;
  studMobileNo: any;
  neetPassword: any;
  neetHtno: any;
  //vitHtno: any;
  VitPassword: any
  studentEmail: any
  jeeFieldsDisabled: boolean = false;
   passwordStatus: any
   jeeMainsDisabled: boolean = false;
  isJeeNotApplied: boolean = false;
  constructor(private jeemains: JeeSession1Service, private spinner: NgxSpinnerService, private dialog: NgDialogAnimationService, private dialogRef: MatDialog, private ngZone: NgZone, private cdRef: ChangeDetectorRef) {
        const today = new Date();
        this.currentDate = today.toLocaleDateString('en-GB'); // dd/MM/yyyy
      }

      ngOnInit(): void {
     // console.log(this.searchCriteria);
     this.getCategoryDetails();
     this.getNeetRookieEnterdData();
    this.getNeetRookieEntereyData();
      
    }

   search(): void {
    if (this.searchCriteria && this.searchCriteria.length > 6) {
      this.jeemains.getNeetRookieAdmNo(this.searchCriteria).subscribe((res: any) => {
        this.options = res;
      });
    }
  }

   optionSelected(option: any, event: any): void {
    if (event.isUserInput) {
      this.searchCriteria = option.admNo; // show admNo in input box
      this.getStudentDetails(option.admNo); // call API to get student details
    }
  }

  getStudentDetails(admNo: string): void {
    this.selectedAdmNo = admNo;
    this.jeemains.getNeetRookieStudentList(admNo).subscribe((res: any) => {
      this.selectedStudent = res;
      this.StudentName = this.selectedStudent?.studentName;
      this.neetApplicationNo = this.selectedStudent?.neetApplicationNo;
      this.disabledFields = !!this.neetApplicationNo;
      this.studMobileNo = this.selectedStudent?.mobileNo;
      this.disabledFields = !!this.mobileNo;
      this.neetPassword = this.selectedStudent?.neetPassword;
      this.disabledFields = !!this.neetPassword;
      this.neetHtno = this.selectedStudent?.neetHtno;
      this.disabledFields = !!this.neetHtno;
      //this.studentEmail = this.selectedStudent?.studentEmail;
     // this.disabledFields = !!this.studentEmail;
      this.categoryList = this.categoryList;
      this.remarksList = this.remarksList
      //this.vitHtno = this.selectedStudent?.VitHtno;
      //this.disabledFields = !!this.vitHtno;
      //this.VitPassword = this.selectedStudent?.VitPassword;
     // this.disabledFields = !!this.VitPassword;
      this.gender = this.selectedStudent.gender;
      this.parentName = this.selectedStudent.parentName;
      this.cityName = this.selectedStudent.cityName;
      this.campusName = this.selectedStudent.campusName;
      this.selectedCategoryId = this.selectedStudent?.categoryId ?? 0;
      this.examType=this.selectedStudent.examType;
     // this.passwordStatus=this.selectedStudent.passwordStatus

      console.log('Student Details:', res);
      //this.clearJeeCheck();
    });
  }

  disabledFields: boolean = false;

   remarksList: string[] = [
    'Under Age',
    'Long Absent',
    'Health Issue',
    'First Year Backlog',
    'Interested in EAMCET or other courses'
  ];
onNumericInput(event: any, fieldName: 'studMobileNo' | 'neetApplicationNo' | 'neetHtno'): void {
    const input = event.target.value.replace(/[^0-9]/g, '');
    event.target.value = input;
    (this as any)[fieldName] = input;
  }

    clearJeeFields() {
  if (this.isJeeNotApplied) {
    //  Checkbox checked — clear and disable
    this.neetApplicationNo = '';
    this.studMobileNo = '';
    this.neetPassword = '';
    this.jeeFieldsDisabled = true;
  } else {
    //  Checkbox unchecked — enable fields again
    this.jeeFieldsDisabled = false;
    this.remarks = '';
  }
}

submitForm() {
  if (!this.searchCriteria) {
    if (!this.searchCriteriaInput.nativeElement.value) {
      alert('Please enter Admission Number');
      setTimeout(() => {
        this.searchCriteriaInput.nativeElement.focus();
      });
      return;
    }
  }

  // if (!this.studentEmail) {
  //   if (!this.studentEmailInput.nativeElement.value) {
  //     alert('Please Enter Student Email');
  //     setTimeout(() => {
  //       this.studentEmailInput.nativeElement.focus();
  //     });
  //     return;
  //   }
  // }

 if (!this.selectedCategoryId) {
  alert('Please select category');
  // Focus the mat-select component
  setTimeout(() => {
    this.selectedCategoryIdInput.nativeElement.focus();
  });
  return;
}


  if (!this.isJeeNotApplied) {
    // if (!this.examType) {
    //   if (!this.examTypeInput.nativeElement.value) {
    //     alert('Please select Exam Type');
    //     setTimeout(() => {
    //       this.examTypeInput.nativeElement.focus();
    //     });
    //     return;
    //   }
    // }

    if (!this.neetApplicationNo) {
      if (!this.jeeMainsAppNoInput.nativeElement.value) {
        alert('Please enter Neet Application Number');
        setTimeout(() => {
          this.jeeMainsAppNoInput.nativeElement.focus();
        });
        return;
      }
    }

    if (this.neetApplicationNo.length < 12) {
      alert('Neet Application Number must be 12 digit number');
      setTimeout(() => {
        this.jeeMainsAppNoInput.nativeElement.focus();
      });
      return;
    }

   

    if (!this.neetPassword) {
      if (!this.jeeMainsPasswordInput.nativeElement.value) {
        alert('Please enter Neet Password');
        setTimeout(() => {
          this.jeeMainsPasswordInput.nativeElement.focus();
        });
        return;
      }
    }

if (!this.neetHtno) {
      if (!this.vitHtnoInput.nativeElement.value) {
        alert('Please enter Neet ht Number');
        setTimeout(() => {
          this.vitHtnoInput.nativeElement.focus();
        });
        return;
      }
    }

    if (this.neetHtno.length < 10) {
      alert('Neet ht Number must be 12 digit number');
      setTimeout(() => {
        this.vitHtnoInput.nativeElement.focus();
      });
      return;
    }

  } 

  if (confirm("Do you want to save?")) {
    const studentData = {
      admNo: this.searchCriteria,
      neetApplicationNo: this.neetApplicationNo,
      neetPassword: this.neetPassword,
      neetHtno: this.neetHtno,
      vitPassword: this.VitPassword,
      appliedStatus: '',
      categoryId: this.selectedCategoryId,
      remarks: this.remarks,
      gender: this.gender,
      StudentName: this.StudentName,
      parentName: this.parentName,
      cityName: this.cityName,
      campusName: this.campusName,
  
    };

    console.log('studentData', studentData);

    this.jeemains.createNeetRookieStudent(studentData).subscribe({
      next: (response) => {
        console.log('Success:', response);
        let resObj;
        try {
          resObj = typeof response === 'string' ? JSON.parse(response) : response;
        } catch (e) {
          resObj = response;
        }

        if (resObj.status === 'OK') {
          alert(resObj.message);
          this.clearForm();
          this.getNeetRookieEnterdData();
          this.getNeetRookieEntereyData();
        } else {
          alert(resObj.message);
        }
      },
      error: (error) => {
        console.error('Error:', error);
        alert('Error saving student.');
      }
    });
  } else {
    console.log("Save cancelled by user.");
  }
}

clearJeeCheck() {
 this.jeeCheck.nativeElement.checked = false;
  }

  @ViewChild('jeeHtnoInput') jeeHtnoInput!: ElementRef<HTMLInputElement>;
  @ViewChild('jeeMainsAppNoInput') jeeMainsAppNoInput!: ElementRef<HTMLInputElement>;
  @ViewChild('studentEmailInput') studentEmailInput!: ElementRef<HTMLInputElement>;
  @ViewChild('selectedCategoryIdInput') selectedCategoryIdInput!: ElementRef<HTMLInputElement>;
  @ViewChild('examTypeInput') examTypeInput!: ElementRef<HTMLInputElement>;
  @ViewChild('studMobileNoInput') studMobileNoInput!: ElementRef<HTMLInputElement>;
  @ViewChild('jeeMainsPasswordInput') jeeMainsPasswordInput!: ElementRef<HTMLInputElement>;
  @ViewChild('vitHtnoInput') vitHtnoInput!: ElementRef<HTMLInputElement>;
  @ViewChild('VitPasswordInput') VitPasswordInput!: ElementRef<HTMLInputElement>;

@ViewChild('searchCriteriaInput') searchCriteriaInput!: ElementRef<HTMLInputElement>;
  
    @ViewChild('pageContainer') pageContainer!: ElementRef;


  @ViewChild('jeeCheck') jeeCheck!: ElementRef<HTMLInputElement>;
  clearForm() {
    this.searchCriteria = '';
    this.studentEmail = '';
    this.examType = '';
    this.neetApplicationNo = '';
    this.neetPassword = '';
    this.neetHtno = '';
    this.neetHtno = '';
    this.VitPassword = '';
    this.studMobileNo = '';
    this.selectedCategoryId = '0';
    this.remarks = '';
    this.jeeCheck.nativeElement.checked = false;
    this.isJeeNotApplied = false;
    this.StudentName = '';
    this.parentName = '';
    this.cityName = '';
    this.campusName = '';
    this.selectedStudent = {} as any;
  }

   onInputField(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;

    // Disable if input is filled with bound data (length check or specific value match)
    if (inputValue != null && inputValue === this.selectedStudent?.neetApplicationNo) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

    if (inputValue != null && inputValue === this.selectedStudent?.neetApplicationNo) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

    if (inputValue != null && inputValue === this.selectedStudent?.mobileNo) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

    if (inputValue != null && inputValue === this.selectedStudent?.neetPassword) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

    if (inputValue != null && inputValue === this.selectedStudent?.neetHtno) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

    if (inputValue != null && inputValue === this.selectedStudent?.studentEmail) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

    if (inputValue != null && inputValue === this.selectedStudent?.neetHtno) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

    if (inputValue != null && inputValue === this.selectedStudent?.VitPassword) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

  }

  columnDefs: ColDef[] = [
      {
        headerName: 'Edit',
        field: 'edit',
        cellRenderer: (params: any) => {
          return `<a style="color:#007BFF; font-weight:bold; cursor:pointer;">Edit</a>`;
        },
        onCellClicked: (params: any) => {
          if (params.data?.admNo) {
            this.onEditClick(params.data.admNo); // directly call component method
          }
        },
        cellStyle: { textAlign: 'center' },
        width: 100
      },
  
  
  
      { headerName: 'AddmissionNo', field: 'admNo', cellStyle: { textAlign: 'left' }, },
      { headerName: 'StudentName', field: 'studentName', cellStyle: { textAlign: 'left' }, },
      { headerName: 'PrentName', field: 'prentName', cellStyle: { textAlign: 'left' }, },
      { headerName: 'className', field: 'className', cellStyle: { textAlign: 'left' }, },
      { headerName: 'NeetAppNo', field: 'NeetAppNo' },
      { headerName: 'NeetHtNo', field: 'neetHtNo' },
      { headerName: 'PasswordStatus', field: 'passwordStatus' }
  
    ];
  
     defaultColDef = {
      // width: 150,
      flex: 1,
      cellStyle: {
        fontFamily: 'medium', textAlign: 'right'
      },
      headerStyle: { fontWeight: 'bold', background: '#0564B1', color: 'white' }
    };
  
    onEditClick(admNo: string): void {
      this.searchCriteria = admNo;
      this.getStudentDetails(this.searchCriteria);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 200);
    }
  
    columnDefsEntry: ColDef[] = [
      {
        headerName: 'Program',
        field: 'program',
        cellStyle: { textAlign: 'left' },
      },
  
      { headerName: 'Total', field: 'total' },
      { headerName: 'NeetApplied', field: 'neetApplied' },
      {
        headerName: 'NeetNotApplied', field: 'neetNotApplied',
      },
      {
        headerName: 'NeetNotEntered', field: 'neetNotEntered', cellStyle: { color: '#fb4700ff', cursor: 'pointer' },
      },
      { headerName: 'valid', field: 'valid' },
      { headerName: 'Invalid', field: 'Invalid' },
      { headerName: 'notVerified', field: 'notVerified' },
    ];

   

  getCategoryDetails(): void {
    this.jeemains.getCategoryList().subscribe((res: any[]) => {
      this.categoryList = res;
      console.log('Category List:', res);
    });
  }

  getNeetRookieEnterdData(): void {
    this.jeemains.getNeetRookieEnteredData().subscribe((data) => {
      console.log(data)
      this.rowData = data;
    });
  }

  getNeetRookieEntereyData(): void {
    this.jeemains.getNeetRookieEntereyDta().subscribe((data) => {
      console.log(data)
      this.rowDataEntry = data;
    });
  }
 onCellClicked(event: any) {
    if (event.colDef.field === 'neetNotEntered') {
      this.getNeetRookieNotAppliedClick(event.data); 
    }
  }

  getNeetRookieNotAppliedClick(data: any) {
  const dialogRef = this.dialog.open(NeetRookieNotAppliedComponent, {
    direction: 'ltr',
    height: '100%',
    width: '45%',
    data: data,
    position: { right: '0px', top: '0px' },
    animation: { to: 'left' }
  });

  dialogRef.afterClosed().pipe(take(1)).subscribe((result: any) => {
    if (result && result.admNo) {
      this.searchCriteria = result.admNo;
      this.getStudentDetails(result.admNo);

      this.ngZone.onStable.pipe(take(1)).subscribe(() => {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          if (this.searchCriteriaInput?.nativeElement) {
            const inputEl = this.searchCriteriaInput.nativeElement as HTMLInputElement;
            inputEl.focus();
            inputEl.select();
          }
        }, 200); 
      });
    }
  });

  this.isJeeNotApplied = false;
}

}
